var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("請先加入好友")]), _c('h5', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("您尚未加入「" + _vm._s(_vm.organization.name) + "」"), _c('br'), _vm._v("請先加入好友才能使用本功能喔！")]), _c('a', {
    staticClass: "btn btn-block primary-button btn-lg",
    attrs: {
      "href": _vm.lineOaUrl,
      "target": "_blank"
    }
  }, [_vm._v("加入好友")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }